import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import type { Game } from '@mwl/core-lib';
import { isLiveCasinoByProductType } from '@mwl/core-lib';

import { routes } from '@/constants';
import { useRouterHistory } from '@/context';

export const useGameGoBack = (game?: Game) => {
  const router = useRouter();
  const { previous } = useRouterHistory();

  const [backUrl, setBackUrl] = useState('');

  const back = useCallback(() => {
    if (window.history.length <= 1 || !backUrl) {
      const pathname = isLiveCasinoByProductType(game?.productType) ? routes.liveCasino.home : routes.casino.home;

      router.push({ pathname });
    } else {
      router.push(backUrl);
    }
  }, [game?.productType, router, backUrl]);

  useEffect(() => {
    const curUrl = router.asPath.split('?')?.[0];
    const prevUrl = previous.split('?')?.[0];

    if (curUrl !== prevUrl) {
      setBackUrl(previous);
    }
  }, [previous, router.asPath]);

  return back;
};
